import React from 'react';
import ErrorIcon from '@material-ui/icons/Error';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    fontWeight: 600,
    fontSize: theme.textFontSize,
    color: theme.ErrorMessageColor,
    border: `1px solid ${theme.ErrorMessageColor}`,
    backgroundColor: theme.errorBGColorSecondary,
    padding: '9px',
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  }
});

const ErrorMessage = ({ error, classes }) => {
  return (
    <div className={classes.container}>
      <ErrorIcon /> <span>{error}</span>
    </div>
  );
};

export default withStyles(styles)(ErrorMessage);
